import React from 'react';
import PropTypes from 'prop-types';
import TitleAndBreadCrumbs from './TitleAndBreadCrumbs';
import Search from './Search';
import PixelTag from './PixelTag';

const Header = props => {
  const mainPageContent = props.structuredPSData?.content || {};
  const { searchBody, searchResult, searchTitle } = mainPageContent;
  const isNewLayoutEligible = props.flatPSData?.isNewLayoutEligible;
  const pixelTagLink =
    'https://insight.adsrvr.org/track/pxl/?adv=mqg6m0a&ct=0:zee3sjq&fmt=3';
  return (
    <section id="appcenter-header">
      <PixelTag pixelTagLink={pixelTagLink} />
      <div
        className={
          isNewLayoutEligible ? 'header-container' : 'header-container old'
        }
      >
        <TitleAndBreadCrumbs {...props} />
        <Search
          app={props.app}
          tools={props.flatPSData?.tools}
          categories={props.flatPSData?.categories}
          appSearch={props.appSearch}
          seoData={props.seo}
          dispatch={props.dispatch}
          updateSearchQuery={props.updateSearchQuery}
          updateSearchResults={props.updateSearchResults}
          clearSearch={props.clearSearch}
          setSearchActive={props.setSearchActive}
          fptiImpression={props.fptiImpression}
          fptiClick={props.fptiClick}
          experimentation={props.experimentation}
          content={{
            searchBody,
            searchResult,
            searchTitle
          }}
          isNewLayoutEligible={isNewLayoutEligible}
        />
      </div>
    </section>
  );
};

Header.propTypes = {
  app: PropTypes.object,
  structuredPSData: PropTypes.object,
  flatPSData: PropTypes.object.isRequired,
  appSearch: PropTypes.object,
  seo: PropTypes.object,
  dispatch: PropTypes.func,
  updateSearchQuery: PropTypes.func,
  updateSearchResults: PropTypes.func,
  clearSearch: PropTypes.func,
  setSearchActive: PropTypes.func,
  fptiImpression: PropTypes.func,
  fptiClick: PropTypes.func,
  experimentation: PropTypes.object
};

export default Header;
